/**
 * Code by Mathieu VANBESELAERE for ->
 * @copyright Copyright (c) Agence ink
 */

// ** Module summary ** //
// If a .navbar-trigger is detected, will hide the navbar blur overlay and make it visible once the trigger is triggered.

// ************** GSAP animation modules (Uncomment required gsap library!) ************** //
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger"; gsap.registerPlugin(ScrollTrigger);
// import ScrollSmoother from "gsap/ScrollSmoother"; gsap.registerPlugin(ScrollSmoother);
// import ScrollToPlugin from "gsap/ScrollToPlugin"; gsap.registerPlugin(ScrollToPlugin);
// import DrawSVGPlugin from "gsap/DrawSVGPlugin"; gsap.registerPlugin(DrawSVGPlugin);
// import MorphSVG from "gsap/MorphSVGPlugin"; gsap.registerPlugin(MorphSVG);
// import SplitText from "gsap/SplitText"; gsap.registerPlugin(SplitText);
// *=====================================================================================* //

export const navbar = () => {
    let navTrigger = document.querySelector(".navbar-trigger");
    if (navTrigger) {
        let navblur = document.querySelector(".navblur");
        gsap.set(navblur, { y: "-100%" });

        ScrollTrigger.create({
            trigger: ".navbar-trigger",
            start: "top top",
            onEnter: () => gsap.to(navblur, { y: "0", ease: "power2" }),
            onLeaveBack: () => gsap.to(navblur, { y: "-100%", ease: "power2" })
        });
    }
    
    return;
};
